<template>

  <div class="ue-expenses-edit">
    <el-card>
      <div class="header">
        <h2>151 - мусор (Год: {{ dto.trancheYear }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="isLoading" v-if="dto.status !== 'APPROVED' && hasEditPermission()">Сохранить</el-button>
        </div>
      </div>

      <form>
        <div class="table-container">
          <table class="grid-table" @paste="handlePaste" @keydown="handleKeydown">
            <thead>
            <tr>
              <th class="header-success" colspan="4"></th>
              <th class="header-success" colspan="11">Вывоз твёрдых бытовых отходов</th>
            </tr>
            <tr>
              <th class="title-cell header-success" rowspan="2">Наименование месяца</th>
              <th class="header-success" rowspan="2">Единица измерения м³ / чел / контейнер</th>
              <th class="header-success" rowspan="2">Общ. площадь здания</th>
              <th class="header-success" rowspan="2">Количество всего потребления</th>
              <th class="header-success" colspan="3">в том числе от зависим.потребления</th>
              <th class="header-success" rowspan="2">Средняя стоимость тарифа</th>
              <th class="header-success" colspan="3">в том числе от зависим.потребления</th>
              <th class="header-success" rowspan="2">Общая стоимость</th>
              <th class="header-success" colspan="3">в том числе от зависим.потребления</th>
            </tr>
            <tr>
              <th class="header-success">Потреб. 1</th>
              <th class="header-success">Потреб. 2</th>
              <th class="header-success">Потреб. 3</th>
              <th class="header-success">Тариф 1</th>
              <th class="header-success">Тариф 2</th>
              <th class="header-success">Тариф 3</th>
              <th class="header-success">Итого 1</th>
              <th class="header-success">Итого 2</th>
              <th class="header-success">Итого 3</th>
            </tr>
            </thead>
            <tbody>
            <tr class="total-row calculated-row readonly-text">
              <td>ВСЕГО</td>
              <td></td>
              <td></td>
              <td>{{ formatNumber(totals.consumption) }}</td>
              <td>{{ formatNumber(totals.consumption1) }}</td>
              <td>{{ formatNumber(totals.consumption2) }}</td>
              <td>{{ formatNumber(totals.consumption3) }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{{ formatNumber(totals.cost) }}</td>
              <td>{{ formatNumber(totals.cost1) }}</td>
              <td>{{ formatNumber(totals.cost2) }}</td>
              <td>{{ formatNumber(totals.cost3) }}</td>
            </tr>
            <template v-for="month in dto.months">
              <tr>
                <td>{{ monthNames[month.month - 1] }}</td>
                <td class="expense-sum-edit" :data-row="month.month - 1" :data-col="0">
                  <el-select v-model="month.unit" placeholder="" clearable>
                    <el-option label="м³" value="м³"/>
                    <el-option label="чел" value="чел"/>
                    <el-option label="контейнер" value="контейнер"/>
                  </el-select>
                </td>
                <td class="expense-sum-edit" :data-row="month.month - 1" :data-col="1">
                  <el-input v-model="month.buildingArea" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate()"/>
                </td>
                <td class="calculated-cell">{{ formatNumber(getConsumption(month)) }}</td>
                <td class="expense-sum-edit" :data-row="month.month - 1" :data-col="2">
                  <el-input v-model="month.consumption1" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate()"/>
                </td>
                <td class="expense-sum-edit" :data-row="month.month - 1" :data-col="3">
                  <el-input v-model="month.consumption2" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate()"/>
                </td>
                <td class="expense-sum-edit" :data-row="month.month - 1" :data-col="4">
                  <el-input v-model="month.consumption3" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate()"/>
                </td>
                <td class="calculated-cell">{{ formatNumber(getAvgTariff(month)) }}</td>
                <td class="expense-sum-edit" :data-row="month.month - 1" :data-col="5">
                  <el-input v-model="month.tariff1" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate()"/>
                </td>
                <td class="expense-sum-edit" :data-row="month.month - 1" :data-col="6">
                  <el-input v-model="month.tariff2" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate()"/>
                </td>
                <td class="expense-sum-edit" :data-row="month.month - 1" :data-col="7">
                  <el-input v-model="month.tariff3" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalculate()"/>
                </td>
                <td class="calculated-cell">{{ formatNumber(getTotalCost(month)) }}</td>
                <td class="calculated-cell">{{ formatNumber(getCost1(month)) }}</td>
                <td class="calculated-cell">{{ formatNumber(getCost2(month)) }}</td>
                <td class="calculated-cell">{{ formatNumber(getCost3(month)) }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </form>
    </el-card>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import authService from "@/services/authService";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";
import {handleGridKeydown} from "@/utils/gridKeyboardNav";

export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      expenseType: 'waste',
      editableFields: ['unit', 'buildingArea', 'consumption1', 'consumption2', 'consumption3', 'tariff1', 'tariff2', 'tariff3'],
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        months: []
      },
      totals: {
        consumption: 0,
        consumption1: 0,
        consumption2: 0,
        consumption3: 0,
        cost: 0,
        cost1: 0,
        cost2: 0,
        cost3: 0
      },
      monthNames: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
    };
  },
  methods: {
    init() {
      this.findById(this.uuid);
    },

    async findById(uuid) {
      this.isLoading = true;
      this.dto = await ueExpensesCommonCrudService.findById(this.expenseType, uuid);

      if (this.dto.months) {
        for (const month of this.dto.months) {
          for (const field of this.editableFields) {
            if (field === 'unit') continue;
            if (month[field] === 0 || month[field] === '0' || month[field] === '0.00' || month[field] === '0.0000') {
              month[field] = '';
            }
          }
        }
      }

      this.sortAndRecalculate();
      this.isLoading = false;
    },
    async submitForm() {
      try {
        if (!this.hasEditPermission()) {
          return;
        }

        this.isLoading = true;
        this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
        this.sortAndRecalculate();
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    sortAndRecalculate() {
      if (this.dto.months && this.dto.months.length > 0) {
        this.dto.months.sort((a, b) => a.month - b.month);
      }
      this.recalculate();
    },

    getConsumption(month) {
      return parseFloat(month.consumption1 || 0) + parseFloat(month.consumption2 || 0) + parseFloat(month.consumption3 || 0);
    },
    getAvgTariff(month) {
      const t1 = parseFloat(month.tariff1 || 0);
      const t2 = parseFloat(month.tariff2 || 0);
      const t3 = parseFloat(month.tariff3 || 0);
      let count = 0;
      let sum = 0;
      if (t1 !== 0) { sum += t1; count++; }
      if (t2 !== 0) { sum += t2; count++; }
      if (t3 !== 0) { sum += t3; count++; }
      return count > 0 ? sum / count : 0;
    },
    getCost1(month) {
      return parseFloat(month.consumption1 || 0) * parseFloat(month.tariff1 || 0);
    },
    getCost2(month) {
      return parseFloat(month.consumption2 || 0) * parseFloat(month.tariff2 || 0);
    },
    getCost3(month) {
      return parseFloat(month.consumption3 || 0) * parseFloat(month.tariff3 || 0);
    },
    getTotalCost(month) {
      return this.getCost1(month) + this.getCost2(month) + this.getCost3(month);
    },

    recalculate() {
      if (!this.dto.months || this.dto.months.length === 0) return;

      let totalConsumption = 0, totalC1 = 0, totalC2 = 0, totalC3 = 0;
      let totalCost = 0, totalCost1 = 0, totalCost2 = 0, totalCost3 = 0;

      for (const month of this.dto.months) {
        const c1 = parseFloat(month.consumption1 || 0);
        const c2 = parseFloat(month.consumption2 || 0);
        const c3 = parseFloat(month.consumption3 || 0);
        const t1 = parseFloat(month.tariff1 || 0);
        const t2 = parseFloat(month.tariff2 || 0);
        const t3 = parseFloat(month.tariff3 || 0);

        totalC1 += c1;
        totalC2 += c2;
        totalC3 += c3;
        totalConsumption += c1 + c2 + c3;

        const cost1 = c1 * t1;
        const cost2 = c2 * t2;
        const cost3 = c3 * t3;
        totalCost1 += cost1;
        totalCost2 += cost2;
        totalCost3 += cost3;
        totalCost += cost1 + cost2 + cost3;
      }

      this.totals = {
        consumption: totalConsumption,
        consumption1: totalC1,
        consumption2: totalC2,
        consumption3: totalC3,
        cost: totalCost,
        cost1: totalCost1,
        cost2: totalCost2,
        cost3: totalCost3
      };
    },

    formatInputNumber(value) {
      if (value === undefined || value === null || value === '') return '';
      const parts = value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    },
    parseInputNumber(value) {
      if (!value) return '';
      let parsed = value.toString().replace(',', '.');
      parsed = parsed.replace(/[^\d.]/g, '');
      const parts = parsed.split('.');
      if (parts.length > 2) {
        parsed = parts[0] + '.' + parts.slice(1).join('');
      }
      return parsed;
    },
    formatNumber(val) {
      if (val === undefined || val === null || isNaN(val) || val === 0) return '';
      const formatted = parseFloat(val).toFixed(2);
      const parts = formatted.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    },

    handleKeydown(event) {
      handleGridKeydown(event, this.$el);
    },
    handlePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('text');

      if (!pastedText) return;

      const rows = pastedText.split(/\r?\n/).filter(r => r.trim() !== '');

      if (rows.length === 1 && rows[0].split('\t').length === 1) return;

      event.preventDefault();

      const activeEl = document.activeElement;
      const cell = activeEl?.closest('td[data-row][data-col]');
      if (!cell) return;

      const startRow = parseInt(cell.dataset.row);
      const startCol = parseInt(cell.dataset.col);

      for (let r = 0; r < rows.length; r++) {
        const cols = rows[r].split('\t');
        const monthIndex = startRow + r;
        if (monthIndex >= 12) break;

        const month = this.dto.months.find(m => m.month === monthIndex + 1);
        if (!month) continue;

        for (let c = 0; c < cols.length; c++) {
          const colIndex = startCol + c;
          if (colIndex >= this.editableFields.length) break;

          const field = this.editableFields[colIndex];
          let value = cols[c].trim().replace(/\s/g, '').replace(',', '.');
          if (field === 'unit') {
            const unitMap = {'м3': 'м³', 'м³': 'м³', 'чел': 'чел', 'контейнер': 'контейнер'};
            month[field] = unitMap[value.toLowerCase()] || '';
          } else {
            month[field] = value === '' || value === '0' ? '' : value;
          }
        }
      }

      this.recalculate();
    },

    goBack() {
      this.$router.go(-1);
    },
    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED' || !this.dto.status);
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

table.expenses-detail tr td {
  padding: 0 !important;
  padding-left: 5px !important;
  font-size: 14px;
}
table.expenses-detail tr td.expense-sum-edit:has(.form-control){
  padding-left: 0 !important;
}

table.expenses-detail tr td.expense-sum-edit .form-control {
  padding-left: 2px !important;
  font-size: 14px !important;
}
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.table-container { width: 100%; overflow-x: auto; }
.grid-table { width: 100%; border-collapse: collapse; min-width: 1800px; }
.grid-table th, .grid-table td { border: 1px solid #EBEEF5; padding: 8px; font-size: 13px; }
.grid-table th { background-color: #f5f7fa; text-align: center; font-weight: bold; position: sticky; top: 0; z-index: 10; }
.header-success { background-color: #d4edda !important; }
.title-cell { width: 150px; }
.calculated-cell { text-align: right; background-color: #f9f9f9; }
.color-red, .color-red:hover {  color: red !important;}
.calculated-row { background-color: #f0f9eb; font-weight: bold; }
.readonly-text { text-align: right; padding-right: 10px !important; }
::v-deep .el-input__inner { text-align: right; font-size: 13px; }
.total-row td {
  font-weight: bold;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
::v-deep input[type=number] {
  -moz-appearance: textfield;
}
</style>
